import styled from 'styled-components';
import { IconButton } from 'ui/button';
import { NegativeFillDiamond } from 'ui/icons/status/NegativeFillDiamond';
import { ChevronDown } from 'ui/icons/navigation/ChevronDown';
import { NavTabsList } from 'ui/tabsGroup';
import { body2, borderRadius, colors, spacing, subtitle1 } from 'ui/theme';

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing.half};
  align-self: stretch;
`;

export const Header = styled.div`
  ${subtitle1}
`;
export const Description = styled.div`
  ${body2};
  display: flex;
  gap: ${spacing.base};
  align-self: stretch;
  justify-content: space-between;
  color: ${colors.secondaryText};
`;

export const StyledTakeoverBody = styled.div``;
export const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: ${spacing.base};
  gap: ${spacing.base};
`;
export const StyledTabsList = styled(NavTabsList)`
  padding-left: ${spacing.base};
  padding-right: ${spacing.base};
  width: 100%;
`;

export const StyledNegativeFillDiamond = styled(NegativeFillDiamond)`
  margin-right: ${spacing.threeEights};
  path {
    fill: ${colors.red100} !important;
  }
`;

export const ChevronUp = styled(ChevronDown)`
  transform: rotate(180deg);
`;

// expected as button & action menu together
export const ComboButton = styled.div`
  display: flex;
  height: 100%;
  > button:first-child {
    height: 100%;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
    border-right: ${spacing.single} solid rgb(0 0 0 / 0.08);
  }
  > *:last-child {
    height: 100%;
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    > div:first-child {
      height: 100%;
      > button:first-child {
        height: 100%;
      }
    }
  }
`;

export const StyledIconButton = styled(IconButton)`
  margin-right: -${spacing.single};
  border-radius: 0 ${borderRadius.md} ${borderRadius.md} 0;
`;
